import React, { Component } from 'react';

const SEVERITY_COLOR = {
  critical: '#b91c1c',
  high: '#d97706',
  medium: '#2563eb',
  low: '#6b7280',
};

const SEVERITY_LABEL = {
  critical: 'Critical',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
};

function getExcerpt(text, maxLen = 120) {
  const normalized = String(text || '').replace(/\s+/g, ' ').trim();
  if (!normalized) return '';
  return normalized.length <= maxLen ? normalized : `${normalized.slice(0, maxLen).trim()}…`;
}

/**
 * IssueReadOnlyCard — side-panel-focused, read-only issue card.
 *
 * Props:
 *  issue: object
 *  defaultExpanded?: boolean
 */
export default class IssueReadOnlyCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: props.defaultExpanded !== false,
      suggestionExpanded: false,
    };
  }

  render() {
    const { issue } = this.props;
    const { isExpanded, suggestionExpanded } = this.state;

    const isDone = issue.status === 'done';
    const isPending = issue.status === 'pending';
    const color = SEVERITY_COLOR[issue.severity] || SEVERITY_COLOR.medium;

    const isProjectLevel = !issue.chapter_id || issue.chapter_number === 0 || issue.chapter_number === null;
    const scopeLabel = isProjectLevel ? 'Project' : `Ch ${issue.chapter_number}`;
    const displayTitle = issue.title || getExcerpt(issue.description) || 'Untitled issue';

    const suggestionText = issue.suggestion;
    const suggestionIsLong = Boolean(suggestionText && suggestionText.length > 120);

    return (
      <div className={`issue-card${isDone ? ' issue-card--resolved' : ''}`}>
        <div
          className="issue-card-header"
          onClick={() => this.setState((s) => ({ isExpanded: !s.isExpanded }))}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && this.setState((s) => ({ isExpanded: !s.isExpanded }))}
          aria-expanded={isExpanded}
        >
          <span className="issue-card-severity-dot" style={{ background: color }} aria-hidden="true" />
          <span className="issue-card-severity-label" style={{ color }}>
            {SEVERITY_LABEL[issue.severity] || 'Medium'}
          </span>
          <span className="issue-card-scope">{scopeLabel}</span>
          <span className="issue-card-title">{displayTitle}</span>
          {isDone && <span className="issue-card-resolved-badge">Done</span>}
          {isPending && <span className="issue-card-pending-badge">Pending</span>}
          <span className="issue-card-chevron" aria-hidden="true">{isExpanded ? '▾' : '▸'}</span>
        </div>

        {isExpanded && (
          <div className="issue-card-body">
            {issue.description && <p className="issue-card-desc">{issue.description}</p>}

            {suggestionText && (
              <div
                className="issue-card-suggestion"
                onClick={suggestionIsLong ? () => this.setState((s) => ({ suggestionExpanded: !s.suggestionExpanded })) : undefined}
                style={suggestionIsLong ? { cursor: 'pointer' } : undefined}
              >
                <strong>Suggestion:</strong>{' '}
                {suggestionIsLong && !suggestionExpanded ? getExcerpt(suggestionText, 120) : suggestionText}
                {suggestionIsLong && (
                  <span className="issue-card-suggestion-chevron" aria-hidden="true">
                    {suggestionExpanded ? ' ▾' : ' ▸'}
                  </span>
                )}
              </div>
            )}

            {issue.issue_type && (
              <p className="issue-card-type">Type: {issue.issue_type.replace(/_/g, ' ')}</p>
            )}

            <div className="issue-card-actions">
            </div>
          </div>
        )}
      </div>
    );
  }
}